import React from "react";
import styled from "styled-components/macro";
import ChromePicker from "react-color/lib/Chrome";
import useOnClickOutside from "use-onclickoutside";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Preview = styled.div`
  width: 70px;
  height: 30px;
  cursor: pointer;
  border: 4px solid #fff;
  outline: 1px solid #d9d9d9;
  background-color: ${props => props.backgroundColor};
`;

const PickerWrapper = styled.div`
  position: absolute;
  margin-top: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
`;

const ColorPicker = ({ color, setColor, ...props }) => {
  const [showPicker, setShowPicker] = React.useState(false);
  const colorPickerRef = React.useRef(null);

  useOnClickOutside(colorPickerRef, () => {
    if (showPicker) setShowPicker(false);
  });

  return (
    <Wrapper {...props}>
      <Preview
        data-test="color-picker-preview"
        onClick={() => {
          !showPicker && setShowPicker(true);
        }}
        backgroundColor={color}
      />
      {showPicker && (
        <PickerWrapper ref={colorPickerRef}>
          <ChromePicker
            disableAlpha={true}
            color={color}
            onChange={color => setColor(color.hex)}
          />
        </PickerWrapper>
      )}
    </Wrapper>
  );
};

export default ColorPicker;
